import 'slick-carousel';

/**
 * Handle Slider
 */
const initSlider = () => {
	$('.js-slider-testimonials .slider__slides').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: false,
		arrows: false,
		dots: true,
		autoplay: true,
  		autoplaySpeed: 6000
	});
}

initSlider();
